import { useImpersonation } from "@hooks/useImpersonation";
import { impersonationService } from "@services/impersonationService";
import { WSBanner } from "@wingspanhq/fe-component-library";
import { ImpersonationGrantLevel } from "@wingspanhq/wingspan-api-sdk";
import React from "react";

/**
 * Always-visible reminder that the app is being viewed as someone else, plus
 * the way back. Rendered from the app layout so it cannot be navigated away
 * from while an impersonation is active.
 */
export const BannerImpersonation: React.FC = () => {
  const impersonation = useImpersonation();

  if (!impersonation) {
    return null;
  }

  const isReadOnly = impersonation.level === ImpersonationGrantLevel.READ_ADMIN;

  return (
    <WSBanner
      theme="warning"
      actions={[
        {
          kind: "Secondary",
          text: "Exit impersonation",
          onClick: () => impersonationService.exit()
        }
      ]}
    >
      {`You are impersonating account ${impersonation.targetAccountId} with ${
        isReadOnly ? "read-only" : "full admin"
      } access. This session is audited.`}
    </WSBanner>
  );
};
